import * as THREE from "three";

export const TEXTURE_URL = "./textures/japan_polygons_small.png";
// export const TEXTURE_URL = "./textures/bulgaria.jpg";

const canvas = document.createElement("canvas");
const context = canvas.getContext("2d", { willReadFrequently: true });

export const getTextureDataPromise = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.src = url;
    image.onload = function () {
      canvas.width = image.width;
      canvas.height = image.height;
      context.drawImage(image, 0, 0);
      context.restore();
      resolve(context);
    };

    image.onerror = function () {
      reject(new Error("Ошибка при загрузке изображения"));
    };
  });

export const textureDataPromise = getTextureDataPromise(TEXTURE_URL);
export const textureLoader = new THREE.TextureLoader();

export const texture = textureLoader.load(TEXTURE_URL);
texture.colorSpace = THREE.SRGBColorSpace;

// export const textureVector = textureLoader.load(
//   "./textures/bulgaria_vector.jpg"
// );
export const textureVector = textureLoader.load(
  "./textures/japan_vector_stroke.jpg"
);
textureVector.colorSpace = THREE.SRGBColorSpace;
